import * as S from './styles';

const FacebookIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/socialIcon-facebook.svg';
const TwitterIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/socialIcon-twitter.svg';
const InstagramIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/socialIcon-instagram.svg';
const YoutubeIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/socialIcon-youtube.svg';
const LinkedInIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/socialIcon-linkedin.svg';
const SpotifyIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/socialIcon-spotify.svg';

const Footer = () => {
  return (
    <S.Footer>
      <S.HeadFooter>
        <p>
          “Somos o Einstein Hospital Israelita e cuidar de você é a nossa
          certeza.”
        </p>
      </S.HeadFooter>
      <S.Container>
        <S.BodyFooter>
          <S.SupportContainer>
            <S.Title>Central de Atendimento</S.Title>
            <a href="tel:+551121511233">+55 (11) 2151-1233</a>
            <p>
              De segunda a sexta, das 7h às 22h. Aos sábados, das 7h às 16h.
            </p>
          </S.SupportContainer>

          <S.TalkContainer>
            <S.Title>Fale Conosco</S.Title>
            <S.Wrapper>
              <a
                href="https://www.einstein.br/atendimento"
                target="_blank"
                rel="noreferrer"
              >
                Queremos ouvir você
              </a>
            </S.Wrapper>
          </S.TalkContainer>
          <S.SocialContainer>
            <S.Wrapper>
              <a
                href="https://www.facebook.com/HospitalAlbertEinstein"
                target="_blank"
                rel="noreferrer"
              >
                <img src={FacebookIcon} alt="Facebook" />
              </a>
              <a
                href="https://www.instagram.com/hosp_einstein/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={InstagramIcon} alt="Instagram" />
              </a>
              <a
                href="https://twitter.com/hosp_einstein"
                target="_blank"
                rel="noreferrer"
              >
                <img src={TwitterIcon} alt="Twitter" />
              </a>
              <a
                href="https://www.linkedin.com/company/hospital-albert-einstein/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={LinkedInIcon} alt="LinkedIn" />
              </a>
              <a
                href="https://www.youtube.com/user/HospitalEinstein"
                target="_blank"
                rel="noreferrer"
              >
                <img src={YoutubeIcon} alt="YouTube" />
              </a>
              <a
                href="https://open.spotify.com/user/hospital_albert_einstein"
                target="_blank"
                rel="noreferrer"
              >
                <img src={SpotifyIcon} alt="Spotify" />
              </a>
            </S.Wrapper>
          </S.SocialContainer>
        </S.BodyFooter>
        <S.CopyContainer>
          <S.TextCopyright>
            Copyright © 2021-2025 Einstein Hospital Israelita. Todos os direitos
            reservados.
          </S.TextCopyright>
          <S.TextPolicesAndTerms
            href="https://www.einstein.br/sobre-einstein/politicas-site"
            target="_blank"
            rel="noreferrer"
          >
            Termos de Uso e Política de Privacidade
          </S.TextPolicesAndTerms>
        </S.CopyContainer>
      </S.Container>
    </S.Footer>
  );
};

export default Footer;
